﻿import { defineComponent, ref, computed, PropType, onMounted } from 'vue';

export default defineComponent({
  name: 'Banner',
  props: {
    compact: { type: Boolean as PropType<boolean>, default: false },
    storageKey: { type: String, default: 'agent-portal-banner:v1' },
    useSession: { type: Boolean, default: false },
  },
  setup(props) {
    const getStore = () => (props.useSession ? window.sessionStorage : window.localStorage);

    // Decide initial visibility BEFORE the first render
    const initialVisible = (() => {
      try {
        if (typeof window === 'undefined') return true; // SSR safety
        const store = getStore();
        return store.getItem(props.storageKey) !== 'hidden';
      } catch {
        return true; // fail open if storage blocked
      }
    })();

    const visible = ref(initialVisible);

    const closeBanner = () => {
      visible.value = false;
      try {
        const store = getStore();
        store.setItem(props.storageKey, 'hidden');
      } catch {
        /* ignore */
      }
    };

    const containerClasses = computed(() =>
      [
        'max-w-7xl mx-auto',
        props.compact ? 'px-4 py-3 sm:px-6' : 'px-6 py-5 sm:px-10 sm:py-6 lg:px-20',
        'text-center',
      ].join(' ')
    );

    const textClasses = computed(() =>
      [props.compact ? 'text-sm sm:text-base' : 'text-base md:text-lg', 'font-medium leading-relaxed'].join(' ')
    );

    return { visible, closeBanner, containerClasses, textClasses };
  },
});
